import { Field, FieldLabel, PromptModal } from '@/components'
import { Textarea } from '@/components/ui'
import type { PromptResolve } from '@ur-solutions/react-components'
import { useTranslate } from '@ur-solutions/react-hooks'
import React, { useState } from 'react'

interface Props {
  initialExplanation?: string

  onSubmit: PromptResolve<string | null>
}

/**
 * Collects the administrator's explanation for flagging a work infringement as
 * wrongly generated. The backend rejects an empty explanation, so submitting is
 * blocked until one is written.
 */
export const WronglyGeneratedPrompt: React.FC<Props> = ({
  initialExplanation = '',
  onSubmit,
}) => {
  const translations = useTranslate({
    title: 'infringements.mark-wrongly-generated',
    description: 'infringements.wrongly-generated-prompt-description',
    explanation: 'infringements.wrongly-generated-explanation',
    submit: 'common.submit',
  })

  const [explanation, setExplanation] = useState(initialExplanation)

  return (
    <PromptModal
      title={translations.title}
      submitText={translations.submit}
      submitDisabled={!explanation.trim()}
      className="w-[600px]"
      cancelOnClickOutside
      cancelOnEscape
      onCancel={() => onSubmit(null)}
      onSubmit={() => onSubmit(explanation.trim())}
    >
      <p className="mt-0 mb-4 text-tertiary">{translations.description}</p>

      <Field>
        <FieldLabel>{translations.explanation}</FieldLabel>
        <Textarea
          value={explanation}
          rows={4}
          autoFocus
          onChange={setExplanation}
        />
      </Field>
    </PromptModal>
  )
}
